$(document).ready(function () {
    'use strict';

    const slider = $('.js_similarOffers');

    if (slider.length > 0) {
        slider.slick({
            centerPadding: 0,
            dots: false,
            arrows: true,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: false,
            nextArrow: '<a class="slick-arrow slick-next"></a>',
            prevArrow: '<a class="slick-arrow slick-prev"></a>',
            responsive: [
                {
                    breakpoint: 1150,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },

                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    }
});
